<template>
  <transition name="fade">
    <div v-show="visible">{{message}}</div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      message: '',
    };
  },
};
</script>

<style scoped>
div {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100px;
  max-width: 418px;
  box-sizing: border-box;
  padding: 16px 20px;
  color: #fff;
  font-size: 14px;
  line-height: 21px;
  background-color: rgba(42, 43, 46, 0.92);
  border-radius: 8px;
  text-align: center;
  transform: translate(-50%, -50%);
  z-index: 10000;
}
/* vue动画过渡效果设置 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
